var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _ellipse, _ellipse2, _ellipse3, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerzekerJeMoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 655.5 501.4",
    style: {
      enableBackground: "new 0 0 655.5 501.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.24;fill:#0E567F;enable-background:new    ;}\n\t.st1{opacity:0.6;fill:#0E567F;enable-background:new    ;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#606161;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:#0E567F;}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:url(#SVGID_12_);}\n\t.st16{fill:url(#SVGID_13_);}\n\t.st17{fill:url(#SVGID_14_);}\n\t.st18{fill:url(#SVGID_15_);}\n\t.st19{fill:url(#SVGID_16_);}\n\t.st20{fill:url(#SVGID_17_);}\n\t.st21{fill:url(#SVGID_18_);}\n\t.st22{fill:url(#SVGID_19_);}\n\t.st23{fill:url(#SVGID_20_);}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:#EFB7B9;}\n\t.st26{fill:url(#SVGID_22_);}\n\t.st27{fill:url(#SVGID_23_);}\n\t.st28{fill:url(#SVGID_24_);}\n\t.st29{fill:none;stroke:#0E567F;stroke-width:4.13;stroke-miterlimit:10;}\n\t.st30{fill:url(#SVGID_25_);}\n\t.st31{fill:url(#SVGID_26_);}\n\t.st32{fill:url(#SVGID_27_);}\n\t.st33{fill:url(#SVGID_28_);}\n\t.st34{fill:url(#SVGID_29_);}\n\t.st35{fill:url(#SVGID_30_);}\n\t.st36{fill:url(#SVGID_31_);}\n\t.st37{fill:url(#SVGID_32_);}\n\t.st38{fill:url(#SVGID_33_);}\n\t.st39{fill:url(#SVGID_34_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.7,321.7c14.2,26.4,28.7,57.6,16.5,85c-8.6,19.2-28.1,30.8-46.8,40.3c-31.1,15.7-63.2,29.2-96.2,40.4 c-20.2,6.8-41,12.8-62.3,13.8c-49.9,2.3-96.2-22.7-142.9-40.3c-49.6-18.8-101.8-29.8-154.7-32.7c-14.8-0.8-29.8-1-43.9-5.4 C20.2,412.3-3.7,375.5,0.5,340c3.1-25.9,18.9-48.8,25.5-73.8c1.3-4.9,2.2-9.8,2.6-14.8c2-24.3-8-50,1.7-72.4 c5.2-11.9,15.5-20.9,26.4-27.8c34-21.4,76.7-26.3,109.5-49.4c22.6-15.9,38.6-39.2,57.1-59.8S265,2.5,292.5,0.2 c38-3.2,76.2,25.2,103.4,48.7c29.2,25.1,61.2,41.5,98.9,52.2c12,3.4,24.3,6.1,36.5,8.9h0.1c15.7,3.6,31.3,7.3,46.5,12.8 c26.9,9.8,52.8,26.5,65.6,52.2c7.4,14.8,9.8,31.5,11.3,48c2,22,1.4,46.9-14.2,62.6c-12.4,12.4-31.8,16.3-45.8,26.3 c-0.5,0.4-1.1,0.7-1.6,1.2C589.9,315.5,587,318.4,584.7,321.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M640.5,285.6c-12.4,12.4-31.8,16.3-45.8,26.3c-85.9,5.7-171.6-16-257.7-21.7c-62.7-4.1-125.6,0.4-188.4-3.8 c-86.5-5.9-3-43.7,32.5-60.5c11.6-5.5,23.9-11,36.6-9.2c7.7,1.2,14.9,5.1,22.7,6.4c31.5,5.3,54.6-32.3,86.2-37.3 c13.1-2.1,26.8,1.8,39.8-1.1c39.4-8.8,51.8-72,92.1-72.4c8.6-0.1,16.9,3,25.5,2.9c6.4-0.1,12.7-2,19-3.2c9.3-1.7,18.8-2.3,28.2-1.8 h0.1c15.7,3.6,31.3,7.3,46.5,12.8c26.9,9.8,52.8,26.5,65.6,52.2c7.4,14.8,9.8,31.5,11.3,48C656.7,245,656.1,269.9,640.5,285.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.3248,
    y1: 432.0778,
    x2: 492.9148,
    y2: -408.1522,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.5,285.6c-12.4,12.4-31.8,16.3-45.8,26.3l-5.9,0.4c-12.8-2.5-27-5-42.8-7.6c-80.2-13.4-301.5-26.7-435-33.9 c3.8-14.1,47.1-34,70.2-44.9c11.6-5.5,23.9-11,36.6-9.2c7.7,1.2,14.9,5.1,22.7,6.4c31.5,5.3,54.6-32.3,86.2-37.3 c13.1-2.1,26.8,1.8,39.8-1.1c39.4-8.8,51.8-72,92.1-72.4c8.6-0.1,16.9,3,25.5,2.9c6.4-0.1,12.7-2,19-3.2c9.3-1.7,18.8-2.3,28.2-1.8 h0.1c15.7,3.6,31.3,7.3,46.5,12.8c26.9,9.8,52.8,26.5,65.6,52.2c7.4,14.8,9.8,31.5,11.3,48C656.7,245,656.1,269.9,640.5,285.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M605.4,390.9c-0.6,5.5-2,10.8-4.2,15.8c-8.6,19.2-28.1,30.8-46.8,40.3c-31.1,15.7-63.2,29.2-96.2,40.4 c-6,2-12,4-18.1,5.7c-14.5,4.3-29.2,7.4-44.2,8.1c-49.9,2.3-96.2-22.7-142.9-40.3c-49.6-18.8-101.8-29.8-154.7-32.7 c-14.8-0.8-29.8-1-43.9-5.4c-34.2-10.5-58.1-47.3-53.9-82.8c3.1-25.9,18.9-48.8,25.5-73.8c6.8,0.4,15.1,0.8,24.6,1.2l14.4,0.7 c13.6,0.7,29.1,1.5,46.1,2.4c133.4,7.2,354.8,20.5,435,33.9c15.8,2.6,30,5.1,42.8,7.6l4.3,0.8c-3.3,2.4-6.1,5.4-8.5,8.7 C596.2,343.1,607.9,367.7,605.4,390.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.9964,
    y1: 211.8062,
    x2: 1460.6266,
    y2: -323.5539,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M605.4,390.9c-0.6,5.5-2,10.8-4.2,15.8c-8.6,19.2-28.1,30.8-46.8,40.3c-31.1,15.7-63.2,29.2-96.2,40.4 c-6,2-12,4-18.1,5.7c-10.9-1.8-21.6-5.6-32.2-9.1c-6.7-2.2-13.6-4.4-20.7-4.4c-3.2,0-6.4,0.4-9.6,0.1c-4-0.4-7.6-2-11.3-3.7 c-35.1-15.4-70.1-30.9-105.1-46.4c-20.7-9.1-41.6-18.4-60.4-31.2c-12-8.2-22.9-17.7-34.7-26.2c-25.5-18.5-54.2-31.7-82.7-44.8 c-15.7-7.2-31.4-14.4-47.1-21.7l13.1-9c-7.2-4.1-14.3-8.2-21.5-12.3c12.6-1.4,25.2-2.8,37.9-4.2c-5-4.2-10-8.5-15.1-12.6 c-1.9-1.7-3.9-3.3-5.8-4.9c3.7,3.1,11.9,4.6,20.3,5.6c7.8,1,15.7,1.6,20.2,2.7c13.9,3.5,27.8,7.5,41.4,12.1 c25.8,8.8,49.8,21.9,75.4,30.8c42.2,14.7,88.9,15.2,132.1,28.9c82.7,26.2,168.4,42,255,47.1C594.6,390.2,600,390.5,605.4,390.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.7981,
    y1: 213.8089,
    x2: 194.091,
    y2: 213.8089,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.7,273.1c-2.5-1.8-5.4-3.1-7.5-5.4c-4.3-4.9-3.6-12.3-5.8-18.4c-2.6-6.9-8.6-12-15.9-13.2 c-3-0.5-6.3-0.3-8.9-1.9c-3.3-2-4.4-6.1-6.1-9.5c-7.3-14.8-29.8-19-41.9-7.8c0.8-7-6.9-12.8-13.9-11.9s-12.4,6.9-14.8,13.5 s-2.3,13.8-2.2,20.8l0.7,45.2c0,2,0.1,4.1,1.2,5.7s3.2,2.6,5.1,3.4c27.4,11,55,21.7,82.7,32.1c13.8,5.2,27.7,10.4,41.5,15.5 c10.6,3.9,24.8,12,36.1,12c0.2-11.9-19.3-24.8-25.1-34.9C145.4,303.8,143.7,283.3,128.7,273.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.9,298.4c0,0-20.4,25.8-0.4,61.5c0,0-7.3,10.2-14.2,0.4s-11.3-64.4,5.8-75.6S203.9,298.4,203.9,298.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.5491,
    y1: 211.1,
    x2: 212.3591,
    y2: 126.56,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.9,298.4c0,0-20.4,25.8-0.4,61.5c0,0-7.3,10.2-14.2,0.4s-11.3-64.4,5.8-75.6S203.9,298.4,203.9,298.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.1,312.8c-0.4-8.9-1.6-18.8-8.3-24.6c-3.9-3.4-9.1-9.1-14.3-8.5c-6.3,0.8-11.9,5.4-15,10.7 c-4,6.9-4.8,15.2-5,23.2c-0.3,11.3,0.5,22.7,2.3,33.9c1,6.5,2.7,13.4,7.4,17.9s11.8,5.9,18.4,6.3c3.2,0.2,6.6,0.2,9.3-1.5 c4.1-2.8,4.8-8.5,5.1-13.4C225.8,342.1,225.8,327.4,225.1,312.8z M195.6,362.6c-6.2,0-11.2-16.7-11.2-37.2s5-37.1,11.2-37.1 s11.2,16.6,11.2,37.1S201.9,362.6,195.6,362.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.3639,
    y1: 119.1032,
    x2: 220.3639,
    y2: 164.3632,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.1,312.8c-0.4-8.9-1.6-18.8-8.3-24.6c-3.9-3.4-9.1-9.1-14.3-8.5c-6.3,0.8-11.9,5.4-15,10.7 c-4,6.9-4.8,15.2-5,23.2c-0.3,11.3,0.5,22.7,2.3,33.9c1,6.5,2.7,13.4,7.4,17.9s11.8,5.9,18.4,6.3c3.2,0.2,6.6,0.2,9.3-1.5 c4.1-2.8,4.8-8.5,5.1-13.4C225.8,342.1,225.8,327.4,225.1,312.8z M195.6,362.6c-6.2,0-11.2-16.7-11.2-37.2s5-37.1,11.2-37.1 s11.2,16.6,11.2,37.1S201.9,362.6,195.6,362.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.6,255.9c-1.6,2.1-3,4.6-3.1,7.2s1.5,5.6,4.1,6.2c3.1,0.7,6.3-1.9,9.4-1.3c0.7,0.3,1.5,0.3,2.3,0.3 c1.1-0.3,1.6-1.6,1.9-2.8c0.6-2.5,1-5.1,1.4-7.7c0.3-1.7,0.3-3.4,0-5.1C198.4,241.7,189.4,250.9,185.6,255.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.8,243.8c-1.4,4.1,0.8,8.6,5,10c1,0.3,2,0.5,3,0.4c1.3-0.2,2.6-0.5,3.9-0.9c2.4-0.6,5-0.7,7.4-0.5 c0.4,0.1,0.8,0.1,1.1-0.1c0.5-0.3,0.5-1.1,0.4-1.7c-0.7-4.3-2.4-13.2-7.3-14.6S181.3,239.4,179.8,243.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.53,
    y1: 247.7775,
    x2: 214.92,
    y2: 247.7775,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M179.8,243.8c-1.4,4.1,0.8,8.6,5,10c1,0.3,2,0.5,3,0.4c1.3-0.2,2.6-0.5,3.9-0.9c2.4-0.6,5-0.7,7.4-0.5 c0.4,0.1,0.8,0.1,1.1-0.1c0.5-0.3,0.5-1.1,0.4-1.7c-0.7-4.3-2.4-13.2-7.3-14.6S181.3,239.4,179.8,243.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M159.5,299.1c-3.2-1.3-7-2.5-10-0.8c-3.5,2-4,6.8-4.1,10.9c0,3.2,0,6.8,2,9.3c1.4,1.7,3.5,2.7,5.5,3.6 l43.9,19.5c1.7,0.8,3.9,1.5,5.3,0.2c0.6-0.7,1-1.5,1.1-2.4c2.4-12.4-4.8-17.7-13.9-24C179.9,308.9,169.9,303.5,159.5,299.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.7097,
    y1: 183.0893,
    x2: 458.5797,
    y2: 66.9193,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.8,304.7c-3.2-1-7-1.9-10-0.6c-3.5,1.5-4,5.1-4.1,8.1c-0.1,2.4,0,5.1,2,7c1.6,1.2,3.5,2.1,5.5,2.6 c14.6,4.9,29,14.4,43.6,19.2c1.7,0.6,3.9,1.1,5.3,0.1c0.6-0.5,0.9-1.1,1.1-1.8c2.4-9.2-6.1-13.2-15.2-17.9 C178.7,316.7,170.2,307.9,159.8,304.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.6,349.5c-0.2,1.4-0.9,2.8-2,3.7c-1.2,0.9-2.6,1.4-4.1,1.4c-0.4,0-0.8,0-1.2-0.1c-2.2-0.4-4.3-1-6.3-1.9 c-4.6-1.9-9.4-3.4-14.2-4.6c-5.3-1.3-10.9-2.2-15.4-5.3c-2.3-1.6-4-3.8-5.1-6.4c-1.2-2.5-1.2-5.3,0-7.8c3.4-7,10.5-4.1,15.7-1.7 c7.2,3.5,14.6,7,21.9,10.4c3.3,1.5,6.8,3.1,9,6.1C203.3,345,203.9,347.3,203.6,349.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.6781,
    y1: 159.0992,
    x2: 295.4781,
    y2: 110.0092,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M201.6,353.6c-1.3,0.7-2.7,1-4.1,1c-0.4,0-0.8,0-1.2-0.1c-2.2-0.4-4.3-1-6.3-1.9c-4.6-1.9-9.4-3.4-14.2-4.6 c-5.3-1.3-10.9-2.2-15.4-5.3c-2.3-1.6-4-3.8-5.1-6.4c3.4-4.9,10.5-2.9,15.7-1.2c7.2,2.5,14.6,4.9,21.9,7.2c3.3,1.1,6.8,2.2,9,4.3 c0.8,0.8,1.4,1.8,1.7,2.9C203.9,351.2,203.1,352.8,201.6,353.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.2,273.1c-4.3,8.6-7.8,17.7-10.3,27.1c-0.5,1.8-0.8,4,0.5,5.3s3.4,1,4.8,0c1.3-1.1,2.4-2.5,3.1-4.1 c1.9-3.3,3.4-6.7,4.6-10.3c-0.3,6.5,1.3,13,4.7,18.6c1.4-3.5,0.3-7.5-0.4-11.2c-0.8-4.4-1.2-8.8-1.1-13.2c2.4,0.5,4,2.9,4.9,5.2 s1.3,4.9,2.9,6.8c1-1.5,1-3.3,1-5.1v-20.8c0.1-0.7-0.1-1.4-0.4-2c-0.5-0.6-1.3-0.9-2.1-0.9C192.4,267.9,187.6,268.3,185.2,273.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.6801,
    y1: 203.0088,
    x2: 236.4901,
    y2: 206.0088,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.2,273.1c-4.3,8.6-7.8,17.7-10.3,27.1c-0.5,1.8-0.8,4,0.5,5.3s3.4,1,4.8,0c1.3-1.1,2.4-2.5,3.1-4.1 c1.9-3.3,3.4-6.7,4.6-10.3c-0.3,6.5,1.3,13,4.7,18.6c1.4-3.5,0.3-7.5-0.4-11.2c-0.8-4.4-1.2-8.8-1.1-13.2c2.4,0.5,4,2.9,4.9,5.2 s1.3,4.9,2.9,6.8c1-1.5,1-3.3,1-5.1v-20.8c0.1-0.7-0.1-1.4-0.4-2c-0.5-0.6-1.3-0.9-2.1-0.9C192.4,267.9,187.6,268.3,185.2,273.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.9,136c-2.1,2.1-3.8,4.6-5.7,6.8c-6.2,7.2-15.4,13.1-16.9,22.6c-0.4,1.6-0.1,3.3,0.8,4.6 c1,1,2.2,1.6,3.6,1.8c8.3,2,17.1,1.2,25-2.1c-9.1,6.6-12.1,18.7-14.2,29.7c-0.9,5.1-1.7,10.9,1.2,15.2c4,5.9,12.6,6,19.8,5.4 l27.1-2.2c4-0.3,8.1-0.7,11.9-2.1s7.3-4,8.9-7.6c2.3-5.2,0.4-11.2,0.5-16.9c0.2-5.6,2.4-11,6.2-15.2c0.5-0.6,1.2-1.2,2-1.5 c1-0.3,2-0.3,3-0.1l34.2,3.7c4.6,0.5,9.4,1,13.8-0.4s8.5-5.2,8.6-9.8c0.1-1.2-0.2-2.3-0.8-3.3c-0.8-1-1.8-1.7-2.9-2.1 c-12-5.7-26.9-5.1-37.1-13.6c-3.9-3.3-6.8-7.7-11-10.6c-3.9-2.7-8.6-4-13.2-5.2c-10.7-2.8-23.6-8.7-34.8-8 C221.2,125.6,209.4,128.2,201.9,136z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.1926,
    y1: 420.082,
    x2: 286.8226,
    y2: 224.282,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M201.9,136c-2.1,2.1-3.8,4.6-5.7,6.8c-6.2,7.2-15.4,13.1-16.9,22.6c-0.4,1.6-0.1,3.3,0.8,4.6 c1,1,2.2,1.6,3.6,1.8c8.3,2,17.1,1.2,25-2.1c-9.1,6.6-12.1,18.7-14.2,29.7c-0.9,5.1-1.7,10.9,1.2,15.2c4,5.9,12.6,6,19.8,5.4 l27.1-2.2c4-0.3,8.1-0.7,11.9-2.1s7.3-4,8.9-7.6c2.3-5.2,0.4-11.2,0.5-16.9c0.2-5.6,2.4-11,6.2-15.2c0.5-0.6,1.2-1.2,2-1.5 c1-0.3,2-0.3,3-0.1l34.2,3.7c4.6,0.5,9.4,1,13.8-0.4s8.5-5.2,8.6-9.8c0.1-1.2-0.2-2.3-0.8-3.3c-0.8-1-1.8-1.7-2.9-2.1 c-12-5.7-26.9-5.1-37.1-13.6c-3.9-3.3-6.8-7.7-11-10.6c-3.9-2.7-8.6-4-13.2-5.2c-10.7-2.8-23.6-8.7-34.8-8 C221.2,125.6,209.4,128.2,201.9,136z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.1672,
    y1: 313.51,
    x2: 278.7972,
    y2: 313.51,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M263.6,198.1c0.2,1.3,0.1,2.7-0.3,3.9c-0.4,1-1.1,1.9-1.9,2.6c-3.4,3.4-7.7,5.7-12.4,6.7 c-0.1-11.2,3.7-22,6.9-32.7c1.6-5.1,2.9-10.3,3.8-15.5c0.8-5.3-0.2-10.6,0.4-15.7c1.5,8,1.2,16.9,1.8,25.1L263.6,198.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M233.3,164.6c-4.8,3.9-14,9.3-20,11.1c-2.7,0.9-5.6,1.1-8.3,2.2c-2,0.9-4,2-5.8,3.3l-25,16.9 c-0.2,0.1-0.4,0.3-0.6,0.6c-0.3,0.7,0.6,1.4,1.3,1.7c5.9,2.5,14.7,11.8,20.6,14.3c-3.4-6.6,0.3-19.1,4.1-24 c5.9-7.4,15.1-11.1,23.5-15.3c8.3-4.1,16.9-9.9,19.6-19.3c0.9-3.1,1.4-6.3,1.6-9.5C240.6,150.5,239.7,159.3,233.3,164.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.9668,
    y1: 294.533,
    x2: 221.7868,
    y2: 321.8029,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M233.3,164.6c-4.8,3.9-14,9.3-20,11.1c-2.7,0.9-5.6,1.1-8.3,2.2c-2,0.9-4,2-5.8,3.3l-25,16.9 c-0.2,0.1-0.4,0.3-0.6,0.6c-0.3,0.7,0.6,1.4,1.3,1.7c5.9,2.5,14.7,11.8,20.6,14.3c-3.4-6.6,0.3-19.1,4.1-24 c5.9-7.4,15.1-11.1,23.5-15.3c8.3-4.1,16.9-9.9,19.6-19.3c0.9-3.1,1.4-6.3,1.6-9.5C240.6,150.5,239.7,159.3,233.3,164.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.5,167.2c-3.4-2-6.5-4.4-10.2-5.7c-3.5-1.2-7.2-1.2-10.9-1.3c-20.5-0.3-41-0.6-61.3,1.2 c-2.6,0.2-5.9,1.1-6.2,3.7c-0.3,1.9,1.4,3.6,3.2,4.1c1.9,0.4,3.8,0.4,5.6,0c7.3-0.8,14.6-1.2,21.9-1.1l34-0.2c2-0.1,3.9,0.1,5.9,0.4 c2.8,0.6,5.3,2.1,7.9,3.2c5.4,2.1,11.3,2.3,17.1,2.5c2.4,0.1,5.9-1.4,2.9-3.6c-1-0.7-3.5-0.5-4.7-0.8 C276.8,169,275.1,168.2,273.5,167.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.5,167.2c-3.4-2-6.5-4.4-10.2-5.7c-3.5-1.2-7.2-1.2-10.9-1.3c-20.5-0.3-41-0.6-61.3,1.2 c-2.6,0.2-5.9,1.1-6.2,3.7c-0.3,1.9,1.4,3.6,3.2,4.1c1.9,0.4,3.8,0.4,5.6,0c7.3-0.8,14.6-1.2,21.9-1.1l34-0.2c2-0.1,3.9,0.1,5.9,0.4 c2.8,0.6,5.3,2.1,7.9,3.2c5.4,2.1,11.3,2.3,17.1,2.5c2.4,0.1,5.9-1.4,2.9-3.6c-1-0.7-3.5-0.5-4.7-0.8 C276.8,169,275.1,168.2,273.5,167.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.4117,
    y1: 335.4651,
    x2: 249.2317,
    y2: 320.1952,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.6,167.3c-3.4-1.9-6.5-4.4-10.2-5.7c-3.5-1.2-7.2-1.3-10.9-1.3c-20.5-0.3-41-0.6-61.3,1.2 c-2.6,0.2-5.9,1.1-6.2,3.7c-0.3,1.9,1.4,3.6,3.2,4.1c1.9,0.4,3.8,0.4,5.6,0c7.3-0.8,14.6-1.2,21.9-1.1l34-0.2c2-0.1,3.9,0.1,5.9,0.4 c2.8,0.6,5.3,2.1,7.9,3.2c5.4,2.1,11.3,2.3,17.1,2.5c2.3,0.1,5.9-1.4,2.9-3.6c-1-0.7-3.5-0.5-4.7-0.8 C276.9,169,275.2,168.3,273.6,167.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.5,160.4c-0.3-1.3-1-2.5-2-3.4c-1-0.9-2.6-1-3.7-0.3c-0.4,0.3-0.7,0.7-1.1,1c-0.6,0.3-1.2,0.5-1.9,0.5 l-23.3,2c-1.1,0-2.1,0.3-3.1,0.8c-1.2,0.9-1.9,2.4-1.7,3.9c0.1,1.5,0.6,2.9,1.3,4.2c0.2,0.5,0.5,0.9,0.9,1.2 c0.6,0.3,1.2,0.4,1.9,0.3l21.1-0.7c1.2-0.1,2.4,0,3.6,0.3C219.3,173,221.5,167.4,219.5,160.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.1891,
    y1: 342.08,
    x2: 216.1891,
    y2: 287.13,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M217.5,162.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.7,0.2-0.9,0.5c-1.1,1.2-2,2.4-2.8,3.8 c-0.1,0.2-0.3,0.4-0.6,0.3l-24.3-0.3c-0.3,0-0.5,0-0.8-0.1c-0.4-0.2-0.7-0.5-0.8-0.9c-0.3-0.7-0.6-1.7-1.3-1.9s-2.7,0-2.8,0.7 c-0.1,1,0.1,2,0.5,2.9c0.2,0.4,0.4,1.4,0.5,1.8c0.3,0.5,0.8,1,1.2,1.4c0.2,0.2,0.5,0.2,0.8,0.3c9.4,1.2,19.5-1.3,29-0.1 c0.8,0.2,1.7,0.1,2.5-0.2c0.5-0.3,0.9-0.8,1.2-1.2C219.9,166.6,219.5,163.7,217.5,162.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.9,235.6c1.7,4.6,4.8,8.6,6.4,13.3c1.4,4.3,1.4,8.9,1.4,13.3c0.1,29.1,1.2,58.1,3.3,87.1 c0,2.8,0.6,5.5,1.5,8.1c1.1,2.5,3.3,4.8,6.1,5.2c4.3,0.6,8-3.4,9.6-7.5c2.7-6.8,2.1-14.4,3.6-21.5c1.7-8.3,6.1-16.3,5.1-24.7 c-0.4-3.8-0.4-10.9-1.4-14.5c-2.1-7.6-0.2-8.1,0-16c0.2-7,0.7-20.6,1.1-27.6c0.4-5.9-2.8-9.6,0.9-14.3c2.1-2.7,5-4.6,7.2-7.1 s14.1-12.7,13.2-13.1s-15.1,1.4-16.2,1.5c-7.6,0.9-15.3,0.4-22.7-1.5c-5.1-1.3-13.6-3.7-17.9,0.8 C189.1,221.4,190.1,230.7,191.9,235.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.2299,
    y1: 204.1019,
    x2: 258.2198,
    y2: 207.0119,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M191.9,235.6c1.7,4.6,4.8,8.6,6.4,13.3c1.4,4.3,1.4,8.9,1.4,13.3c0.1,29.1,1.2,58.1,3.3,87.1 c0,2.8,0.6,5.5,1.5,8.1c1.1,2.5,3.3,4.8,6.1,5.2c4.3,0.6,8-3.4,9.6-7.5c2.7-6.8,2.1-14.4,3.6-21.5c1.7-8.3,6.1-16.3,5.1-24.7 c-0.4-3.8-0.4-10.9-1.4-14.5c-2.1-7.6-0.2-8.1,0-16c0.2-7,0.7-20.6,1.1-27.6c0.4-5.9-2.8-9.6,0.9-14.3c2.1-2.7,5-4.6,7.2-7.1 s14.1-12.7,13.2-13.1s-15.1,1.4-16.2,1.5c-7.6,0.9-15.3,0.4-22.7-1.5c-5.1-1.3-13.6-3.7-17.9,0.8 C189.1,221.4,190.1,230.7,191.9,235.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M342.2,226.8l43.8,112.3c0,0,1.5,6.6,7.4,4.6c3.7-1.3,7-3.4,9.7-6.2l-47.6-112.7l-5-9.7l-19.8-39.9l-5,1.6 l-2.3,10.4L342.2,226.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.9539,
    y1: 229.6899,
    x2: 388.0439,
    y2: 237.6799,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M342.2,226.8l43.8,112.3c0,0,1.5,6.6,7.4,4.6c3.7-1.3,7-3.4,9.7-6.2l-47.6-112.7l-5-9.7l-19.8-39.9l-5,1.6 l-2.3,10.4L342.2,226.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M227.2,285.2l1-29.2c0.2-3.7,0.1-7.4-0.4-11.1c-0.4-2.1-0.9-4.3-0.5-6.4c0.7-3.4,3.9-5.6,6-8.4 c3.1-4.2,3.8-9.6,6.1-14.3c3.5-7.2,10.6-12.2,18.2-14.9s15.7-3.4,23.7-4c9.9-0.8,19.2-7.1,29.1-7.4s20.6,3.3,26.3,11.5 c6.9,10,5,24.1,11.7,34.3c1.7,2.6,4,4.9,5.1,7.9c1.9,5-0.2,10.6-3.2,15c-3,4.4-7,8-9.9,12.5c-6.8,10.8-5.7,24.4-5.5,37.1 c0.3,20.2-2,40.4-7,60c-0.4,2.3-1.4,4.6-2.7,6.6c-3,4-8.7,4.9-13.7,4.5s-10.1-1.7-15-0.8c-7.4,1.3-13.5,7.2-21,8 c-5.5,0.5-10.7-1.8-15.7-4l-24-10.9c-3.6-1.6-7.4-3.4-10.1-6.4c-4.8-5.3-5.1-13.3-3.2-20.1s5.4-13.1,7.8-19.8s3.3-14.4-0.1-20.6 c-1-1.9-2.4-3.5-3.3-5.5C224.9,294.5,227,289.7,227.2,285.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.6436,
    y1: 262.9455,
    x2: 456.6136,
    y2: 105.8655,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M227.2,285.2l1-29.2c0.2-3.7,0.1-7.4-0.4-11.1c-0.4-2.1-0.9-4.3-0.5-6.4c0.7-3.4,3.9-5.6,6-8.4 c3.1-4.2,3.8-9.6,6.1-14.3c3.5-7.2,10.6-12.2,18.2-14.9s15.7-3.4,23.7-4c9.9-0.8,19.2-7.1,29.1-7.4s20.6,3.3,26.3,11.5 c6.9,10,5,24.1,11.7,34.3c1.7,2.6,4,4.9,5.1,7.9c1.9,5-0.2,10.6-3.2,15c-3,4.4-7,8-9.9,12.5c-6.8,10.8-5.7,24.4-5.5,37.1 c0.3,20.2-2,40.4-7,60c-0.4,2.3-1.4,4.6-2.7,6.6c-3,4-8.7,4.9-13.7,4.5s-10.1-1.7-15-0.8c-7.4,1.3-13.5,7.2-21,8 c-5.5,0.5-10.7-1.8-15.7-4l-24-10.9c-3.6-1.6-7.4-3.4-10.1-6.4c-4.8-5.3-5.1-13.3-3.2-20.1s5.4-13.1,7.8-19.8s3.3-14.4-0.1-20.6 c-1-1.9-2.4-3.5-3.3-5.5C224.9,294.5,227,289.7,227.2,285.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.79,
    y1: 209.3716,
    x2: 368.2487,
    y2: 209.3716,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M285.4,204.2c1.3,5.4,1.9,11,1.7,16.6c-0.6-3.1-4.9-3.6-8-3.1c-12.3,2.3-23,9.8-29.4,20.5l19.1,17 c0.7-6-7.1-11.5-4.5-16.9c1.1-2.4,3.8-3.5,6.2-4.4l21.1-8c5.6,3.6,6.2,11.8,4,18.1s-6.3,11.8-8.3,18.2c-1.7,5.4-1.7,11.1-2.9,16.6 c-2.8,12.9-11.7,23.5-18,35.2c-6.9,12.7-10.6,26.8-11,41.3c-0.1,5.8,0.3,12,3.3,17s9.1,8.5,14.8,6.9l1.8-16.2 c1.8-16.1,4.2-33.5,15.4-45.2c7.4,15-1.9,36.1,9.7,48.2c2,2.1,4.8,3.8,7.7,3.2c3.6-0.7,5.6-4.6,6.7-8.2c5.5-17.8,1.9-37.3,7.1-55.2 c2.5-8.5,6.8-16.3,10.6-24.2c3.9-8.2,16-22.6,18.8-31.3c2.1-6.7,2.5-5.2,0.5-12c-2.2-7.8-16-15.9-19.5-22.9 c-4.5-8.8-3.4-26.7-14.8-27.6c-6.1-0.5-10,0.4-15.5,3.6C290.2,197.7,282.4,192,285.4,204.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.9295,
    y1: 203.775,
    x2: 355.62,
    y2: 203.775,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M340.5,270.6c-6.8,10.8-5.7,24.4-5.5,37.1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M446.5,347.4c-4.5-56.4-38.3-99.8-75.4-96.9s-63.6,51.1-59.1,107.6s38.2,99.8,75.4,96.8S451,403.9,446.5,347.4z  M378.7,431.7c-18-8.9-33.1-40-36.1-78.1c-3.2-40.4,8.2-75.2,26.4-84.7c18,8.9,33.1,40,36.1,78.1 C408.3,387.4,396.9,422.2,378.7,431.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.8272,
    y1: 152.4556,
    x2: 466.4473,
    y2: 94.6456,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M446.5,347.4c-4.5-56.4-38.3-99.8-75.4-96.9s-63.6,51.1-59.1,107.6s38.2,99.8,75.4,96.8S451,403.9,446.5,347.4 z M378.7,431.7c-18-8.9-33.1-40-36.1-78.1c-3.2-40.4,8.2-75.2,26.4-84.7c18,8.9,33.1,40,36.1,78.1 C408.3,387.4,396.9,422.2,378.7,431.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.7,431.7c-2.6,1.4-5.5,2.3-8.4,2.5c-22.9,1.8-44.5-34.3-48.1-80.6s11.9-85.3,34.8-87.2 c4.2-0.3,8.3,0.6,12,2.5c-18.2,9.5-29.6,44.3-26.4,84.7C345.6,391.7,360.7,422.8,378.7,431.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.7015,
    y1: 142.5962,
    x2: 393.8,
    y2: 142.5962,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.7,431.7c-2.6,1.4-5.5,2.3-8.4,2.5c-22.9,1.8-44.5-34.3-48.1-80.6s11.9-85.3,34.8-87.2 c4.2-0.3,8.3,0.6,12,2.5c-18.2,9.5-29.6,44.3-26.4,84.7C345.6,391.7,360.7,422.8,378.7,431.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M322.1,165.4c13.1,0.1,25.7,4.6,38,9c0.9,0.2,1.6,0.7,2.1,1.4c0.4,1.2,0,2.5-1.1,3.1c-1.1,0.5-2.3,0.7-3.5,0.6 c-11-0.3-21.1-5.2-31.9-6.3c-3.3-0.3-11.2,1.3-12.7-2.9C311.5,165.8,319.2,165.4,322.1,165.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M275.3,113.8c-0.1,5.5-3.6,10.3-8.8,12.2c-1.6,0.4-3.1,0.9-4.7,1.5c-1,0.4-1.9,1-2.5,1.9 c-0.7,1.1-1,2.4-0.9,3.7c0,3.3,0.8,6.6,1,9.9c0,0.3,0,0.7,0,1c0.1,3-0.4,6.2-2.4,8.4c-1.2,1.6-3.2,2.4-5.2,2 c-1.7-0.5-2.9-2.1-3.9-3.5c-3.8-5.8-6.8-12.2-8.9-18.8c-0.3-0.9-0.6-1.8-1-2.6c-0.3-0.4-0.5-0.9-0.7-1.4c-0.1-0.7,0-1.5,0.2-2.2 c0.7-2.6,1.5-5.1,2.4-7.6c0.7-1.5,1.2-3.1,1.3-4.7c0.1-3.1-2.1-5.8-2.7-8.8c-0.6-2.8,0.1-5.7,0.9-8.4c0.3-1.3,0.8-2.5,1.6-3.5 c0.8-0.9,1.7-1.7,2.8-2.2c5.9-3.3,12.9-3.8,19.6-3.6c1.8,0,3.5,0.3,5.2,0.9c1.7,0.6,3,2,3.5,3.7c0.5,1.9,0,4,0.2,5.9 c0.1,1.3,0.4,2.6,0.6,3.9C273.7,105.6,275.4,109.7,275.3,113.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M243.9,97.6c0.1,3.2,0.4,6.4,1.1,9.5l-3.1-4.6c-0.3-0.6-0.8-1-1.4-1.2c-0.8,0-1.5,0.5-1.6,1.2 c-0.2,0.7-0.1,1.5,0.2,2.2c1,3.4,3.1,6.5,3.2,10c0,0.9-0.2,1.9-1,2.2c-1-3-2.3-6-3.9-8.8c-1.7-3-3.6-5.8-4.9-9 c-1.3-3.2-1.9-6.6-1.8-10c0-1.1,0.2-2.2,0.8-3.2c0.4-0.7,1.1-1.2,1.5-1.9s0.5-1.4,0.9-2.1c1-2,3.4-2.8,5.6-3.3c4.6-1,9.3-1.6,14-1.8 c2.7-0.2,5.5,0,8.1,0.7c2.7,0.7,5,2.3,6.5,4.6c0.6,0.9,1,2,1.6,2.9c0.5,0.6,1,1.3,1.4,2c0.4,0.7,0.5,1.6,0.1,2.3 c-0.7,1.2-2.3,1.1-3.7,0.9c-4.1-0.7-8.5-1.4-12.5-0.3c-1.5,0.6-3.1,1.1-4.8,1.4c-1.1,0.1-2.2-0.3-3.4-0.2 C243.6,91.1,243.9,95.4,243.9,97.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.7545,
    y1: 448.561,
    x2: 273.5645,
    y2: 368.401,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M243.9,97.6c0.1,3.2,0.4,6.4,1.1,9.5l-3.1-4.6c-0.3-0.6-0.8-1-1.4-1.2c-0.8,0-1.5,0.5-1.6,1.2 c-0.2,0.7-0.1,1.5,0.2,2.2c1,3.4,3.1,6.5,3.2,10c0,0.9-0.2,1.9-1,2.2c-1-3-2.3-6-3.9-8.8c-1.7-3-3.6-5.8-4.9-9 c-1.3-3.2-1.9-6.6-1.8-10c0-1.1,0.2-2.2,0.8-3.2c0.4-0.7,1.1-1.2,1.5-1.9s0.5-1.4,0.9-2.1c1-2,3.4-2.8,5.6-3.3c4.6-1,9.3-1.6,14-1.8 c2.7-0.2,5.5,0,8.1,0.7c2.7,0.7,5,2.3,6.5,4.6c0.6,0.9,1,2,1.6,2.9c0.5,0.6,1,1.3,1.4,2c0.4,0.7,0.5,1.6,0.1,2.3 c-0.7,1.2-2.3,1.1-3.7,0.9c-4.1-0.7-8.5-1.4-12.5-0.3c-1.5,0.6-3.1,1.1-4.8,1.4c-1.1,0.1-2.2-0.3-3.4-0.2 C243.6,91.1,243.9,95.4,243.9,97.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M325.1,182.9c0,1-0.3,2-0.9,2.8c-1.2,1.7-3.5,2.9-5.5,3.7c-4.6,1.8-9.5,3.7-14.5,3.1c-3.6-0.5-7-2.2-10.2-4 c-2.7-1.4-5.4-2.9-8-4.3c-4.9-2.6-9.8-5.4-13.4-9.7c-5.1-6.2,0-10.5,4.4-15c1-1,2-2,3.2-2.8c4-3.2,8.7-5.3,13.7-6.1 c3.3-0.5,6.9-0.5,9.9,1c2.1,1.3,4,2.9,5.5,4.8c6.2,7.2,11.3,15.3,15.1,23.9C324.8,181.1,325,182,325.1,182.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.9006,
    y1: 330.9423,
    x2: 355.2306,
    y2: 284.4023,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M325.1,182.9c0,1-0.3,2-0.9,2.8c-1,0.6-2,1.1-3,1.5c-4.6,1.9-9.5,3.7-14.5,3.1c-3.7-0.5-7-2.2-10.2-4 c-2.7-1.4-5.3-2.9-8-4.3c-4.8-2.6-9.8-5.4-13.3-9.7c-5.1-6.2,0-10.5,4.4-15c0.2-0.2,0.5-0.4,0.7-0.6c4-3.2,8.7-5.3,13.7-6.1 c3.3-0.5,6.9-0.5,9.9,1c2.1,1.3,4,2.9,5.5,4.8c6.2,7.2,11.3,15.3,15.1,23.9C324.8,181.1,325,182,325.1,182.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M279,185.8l48.4,149.1c0,0,6.2,18.6,8.1,22.1s10.5,0.8,11.2-0.8s2.7-6.2,2.7-6.2l-48.8-134.4l-12.4-34.8 C288.3,180.7,279,178,279,185.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.9054,
    y1: 222.8439,
    x2: 337.9054,
    y2: 226.8439,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M279,185.8l48.4,149.1c0,0,6.2,18.6,8.1,22.1s10.5,0.8,11.2-0.8s2.7-6.2,2.7-6.2l-48.8-134.4l-12.4-34.8 C288.3,180.7,279,178,279,185.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.2,217.9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M335.4,251.4c1.7-2.2,3.6-4.1,5.9-5.7c2.9-1.9,6.2-2.7,9.6-3.5c13.9-3.1,28.8-5.3,41.9,0 c1.8,0.6,3.3,1.6,4.5,3.1c1.1,1.5,1.4,3.7,0.1,5.1c-1.1,1.2-2.9,1.4-4.5,1.5c-14.4,0.7-29.2-0.2-42.7,4.8 c-9.5,3.5-17.7,9.7-25.4,16.3c-5,4.3-4.8-3.6-2.5-6.4C326.5,261.4,331.2,256.5,335.4,251.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1462,
    y1: 238.1507,
    x2: 372.3262,
    y2: 255.2407,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M335.4,251.4c1.7-2.2,3.6-4.1,5.9-5.7c2.9-1.9,6.2-2.7,9.6-3.5c13.9-3.1,28.8-5.3,41.9,0 c1.8,0.6,3.3,1.6,4.5,3.1c1.1,1.5,1.4,3.7,0.1,5.1c-1.1,1.2-2.9,1.4-4.5,1.5c-14.4,0.7-29.2-0.2-42.7,4.8 c-9.5,3.5-17.7,9.7-25.4,16.3c-5,4.3-4.8-3.6-2.5-6.4C326.5,261.4,331.2,256.5,335.4,251.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.9,225.9c-7,4.1-14.4,8.8-22.5,8.5c-1.8-0.2-3.5-0.2-5.3-0.1c-1.8,0.3-3.5,1.5-3.8,3.2 c-0.6,3.3,3.8,5,7.1,4.9c6-0.3,12.2-2.5,17.7-0.1c2,1,3.8,2.2,5.5,3.8l22.7,19.2c1.6,1.4,3.3,2.9,4.1,4.9s0.5,4.2,0.8,6.4 s1.5,4.5,3.6,4.8c3.2,0.4,4.8-3.7,5.5-6.9c1.2-4.7,3.2-9.2,6-13.2c2-2.8,4.3-5.5,5.5-8.7s0.9-7.4-1.8-9.5c-0.7-0.6-1.7-0.9-2.6-0.9 c-0.9,0.2-1.8,0.7-2.5,1.4c-5.1,4.5-9.2,10-12.2,16.1l-23-19.2c-1.2-1-2.5-2.1-2.6-3.7c-0.2-2.1,1.8-3.8,3.6-4.9 c7.3-4.6,14.9-8.5,22.9-11.7c2.4-1,10.3-3.8,9.5-7.6s-9.8,0.6-12.1,1.4C269.9,217.2,261.2,221.2,252.9,225.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M277.1,288c-4.7,4.2-7.4,10.1-9.8,15.8c-6.5,15.3-12,31-16.3,47c-1.8,6.5-3.4,13.4-2.2,20.1s5.9,13.2,12.6,14.4 c1.2,0.2,2.7,0.1,3.3-0.9s-0.1-2.5-0.7-3.6c-2.9-5.4-3.7-11.6-3.9-17.7c-0.6-21.7,5.4-43.2,17.1-61.5c2.7-4.2,6-8.5,10.6-10.5 c2.9-1.3,12.5-4.4,6.2-7.4C288.9,281.2,280.9,284.6,277.1,288z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M292.7,292.2c-2.7,5.2-5.8,10.7-5,16.4c1,6.8,7.3,11.5,14.1,10.4c1.1-0.2,2.2-0.5,3.2-0.9 c1.6-0.7,3-1.7,4.6-2.5c3.5-1.5,7.4-1.5,10.8,0.1c0.2-1.7-1.3-3.3-2.9-3.9c-1.7-0.4-3.5-0.5-5.2-0.2l-9.2,1 c-2.9,0.3-6.1,0.6-8.5-1.1c-2.8-1.9-3.4-5.8-3.2-9.1c0.5-6.2,3.2-12.1,6.7-17.3c2.2-3.3,4.7-6.5,6-10.2c1.1-3.2,1.4-7.9-1.5-10 C299,273.9,297.2,283.5,292.7,292.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.5,257.8c-0.3,0.8-0.6,1.7-0.7,2.5c-0.1,0.8,0,1.6,0.1,2.4l2,15.8c0.1,1.6,0.4,3.2,1,4.7 c0.4,1,1,1.9,1.4,2.9c0.5,1.7,0.6,3.5,0.3,5.2l-1.2,15.6c0,0.7-0.1,1.4-0.4,2c-1,1.8-4,1.6-5.3,0s-1.6-3.8-1.8-5.9l-0.8-10.3 c-0.3-2.9-0.3-5.8-0.1-8.7c0.3-1.9,0.8-3.8,1.1-5.7c1.6-10.5-3.6-21.1-2.2-31.6c0.1-0.8,0.3-1.6,0.8-2.3c1.9-2.7,6-1.1,7,1.3 C247,248.4,245.5,254.9,244.5,257.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.5876,
    y1: 161.9309,
    x2: 249.9665,
    y2: 161.9309,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M216,306.8c-3.5,3.7-5.8,8.3-7.9,12.9c-1.1,2.2-2,4.4-2.8,6.7c-2.4,7.4-2.1,15.4-1.4,23.1 c0.3,2.7,0.6,5.6,2.1,7.8c2.6,3.9,7.9,4.9,11.7,2.3c0.7-0.5,1.3-1,1.8-1.6c1.5-1.8,2.2-4.1,2.9-6.3c2.3-6.8,5.6-13.2,8.2-19.9 s4.6-13.8,4-21c-0.3-3.7-1.7-9.5-6-9.8C223.9,300.6,219.1,303.4,216,306.8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M310.5,189.9c-1.2,1.2-2.3,2.5-3.4,3.8c-2.6,3-4.5,6.6-5.6,10.4c-1.9,7.7,1.7,16.2,8,20.9s15.1,5.6,22.6,3.3 c1.4-0.4,2.7-1,3.8-1.9c1-1.1,1.8-2.4,2.3-3.8c1.3-2.9,2.7-6,2.9-9.2c0.1-3-0.5-5.9-1.6-8.7c-2.4-6.5-6.3-12.4-11.2-17.3 c-3-2.9-4.3-3.9-8.5-2.7C316.3,185.7,313.1,187.4,310.5,189.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 331.9,
    cy: 206.8,
    rx: 21.3,
    ry: 22.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.2278,
    y1: 323.5328,
    x2: 309.4178,
    y2: 277.1728,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st32",
    cx: 331.9,
    cy: 206.8,
    rx: 21.3,
    ry: 22.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.4085,
    y1: 321.1219,
    x2: 312.7585,
    y2: 278.9119,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 333.2,
    cy: 206.7,
    rx: 19.4,
    ry: 20.8
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241,101.1l5.9-2.7l28.4-1.4c0,0,0.5,5.9-0.5,7.1s-6,0.1-7.2-2.3l-1.2-2.7l-2.2,0.4c0,0,0.3,6.4-4.4,6.8 s-8.9,0.6-9.4-0.8c-1-1.8-2.2-3.6-3.4-5.3l-5,2.4L241,101.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.3429,
    y1: 404.2905,
    x2: 276.5229,
    y2: 375.6605,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M241,101.1l5.9-2.7l28.4-1.4c0,0,0.5,5.9-0.5,7.1s-6,0.1-7.2-2.3l-1.2-2.7l-2.2,0.4c0,0,0.3,6.4-4.4,6.8 s-8.9,0.6-9.4-0.8c-1-1.8-2.2-3.6-3.4-5.3l-5,2.4L241,101.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M210.7,164.8c-0.1,1.2-0.4,2.3-0.9,3.4c-0.5,1.1-1.6,1.8-2.8,1.9c-1.3,0-2.5-0.9-3.7-0.7 c-0.5,0.1-1,0.3-1.4,0.4c-1.4,0.4-2.8-0.3-4.2-0.1c-0.6,0.1-1.2,0.4-1.9,0.5c-2.5,0.5-4.9-0.8-5.8-3.2c-0.4-1.1-0.4-2.4-1.1-3.5 c-0.6-0.8-1.6-1.6-1.3-2.6c0.1-0.4,0.3-0.7,0.6-1c4-3.8,9.6-3.6,14.8-4.2C208.5,155.3,211.3,159.6,210.7,164.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M330.4,162.3c1.7-0.2,3.5-0.2,5.2,0.2c2.8,0.5,5.6,1.2,8.3,2.1c1.1,0.3,2.2,0.8,3.3,1.4 c2.7,1.7,4.3,4.6,4.3,7.8c0,1.3-0.3,2.5-1.1,3.5c-1.6,2-4.7,1.9-7.3,1.6c-2.8-0.3-5.9-0.8-7.4-3.2c-0.9-1.4-0.9-3.2-1.1-5 s-0.8-3.5-2.4-4.3c-1-0.5-5.3,0-5.6-1.4C326.2,163.4,329.2,162.5,330.4,162.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.8007,
    y1: 205.1416,
    x2: 452.8807,
    y2: 70.9716,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M348.9,301.1c15-1.1,30.1,9.8,33.7,24.4c-5.6-6-14.3-8-21.9-4.9c7.8,5.3,13.6,12.9,16.6,21.7l-3.3-1.9 c4.3,15.7,2,32.5-6.3,46.5l10.4-17.2c-0.4,6.8-1.5,13.8-5.3,19.5s-10.6,9.8-17.3,8.6c9.2,3.4,19.5,2.5,27.9-2.6 c-2.3,5.1-4.8,10-7.5,14.8c15.6-19.6,22.5-44.7,18.9-69.5c0.8,8.7,0.7,17.5-0.3,26.1c7.7-24.6,3.4-51.3-11.4-72.4 c1.5,6.4,1.7,13.1,0.4,19.6c-3.9-9.3-9.3-19.8-19.2-21.7c2.5,0.9,5,0.7,6.6-0.8C363,289.4,353.4,294.4,348.9,301.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M233.7,117.9c-2.1,1.2-3,4-2.8,6.4s1.1,4.8,1.7,7.2c1,4.4,1.5,8.9,1.6,13.4c3.9-0.6,7.8,0.2,11.1,2.3 C243.5,142.7,242.5,112.7,233.7,117.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M274.4,139.6c-5.3,0.4-9.4,4.9-14.5,6c-0.6-1.4-0.8-2.8-0.8-4.3l-0.4-7.4c-0.1-1.3-0.2-3.9,0.9-4.8 c1.7-1.5,3.1,0.2,4.8,1.4C268,133.2,271.4,136.2,274.4,139.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.8279,
    y1: 383.4991,
    x2: 259.8279,
    y2: 342.0491,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M233.7,117.9c-2.1,1.2-3,4-2.8,6.4s1.1,4.8,1.7,7.2c1,4.4,1.5,8.9,1.6,13.4c3.9-0.6,7.8,0.2,11.1,2.3 C243.5,142.7,242.5,112.7,233.7,117.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.7046,
    y1: 393.002,
    x2: 281.7046,
    y2: 351.552,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M274.4,139.6c-5.3,0.4-9.4,4.9-14.5,6c-0.6-1.4-0.8-2.8-0.8-4.3l-0.4-7.4c-0.1-1.3-0.2-3.9,0.9-4.8 c1.7-1.5,3.1,0.2,4.8,1.4C268,133.2,271.4,136.2,274.4,139.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.0431,
    y1: 352.4879,
    x2: 280.5131,
    y2: 362.0078,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M261.6,130.4c-0.8,2.5-1,5.1-0.6,7.7c0.3,1,0.4,2.1,0.4,3.2c0,1.1-0.6,2.1-1.6,2.7c-0.1,0-0.2,0.1-0.3,0.1 c0-0.3,0-0.7,0-1c-0.3-3.3-1.1-6.6-1-9.9c-0.1-1.3,0.2-2.6,0.9-3.7c0.6-0.9,1.5-1.6,2.5-1.9c0.1,0,0.1,0,0.2,0.1 C262.9,128.3,262,129.3,261.6,130.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.3011,
    y1: 342.9888,
    x2: 377.1011,
    y2: 463.5088,
    gradientTransform: "matrix(1 0 0 -1 -15.13 492.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#010101"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M259.4,129.4c-0.7,1.1-1,2.4-0.9,3.7c0,3.3,0.8,6.6,1,9.9c0,0.3,0,0.7,0,1c-1.2,0.2-2.3-0.1-3.2-0.9 c-1.8-1.6-3.2-3.6-4.1-5.9c-0.7-1.4-1.2-3-1.4-4.6c-0.2-1.6,0.4-3.3,1.5-4.4c1.4-1.3,3.6-1.4,5.5-1.2c0.7,0.1,3.2,0,4.1,0.4 C260.8,127.8,259.9,128.5,259.4,129.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerzekerJeMoto);
export default __webpack_public_path__ + "static/media/verzekerJe-moto.364cf7ed1186ac3e0460ec96ebab428e.svg";
export { ForwardRef as ReactComponent };